/*eslint-disable */
import { Box, Button, ListItem, Menu, MenuItem, TextField, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import DeleteIcon from "@mui/icons-material/Delete";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RefreshIcon from "@mui/icons-material/Refresh";

export default function DraggableComponentItems({ index, getItemStyle, item, expandedIndex, handleReadMore, handleReadLess, handleDelete, advanceSubtopicData }) {
  const [count, setCount] = useState(item.Count);
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [open1, setOpen1] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [validationMessage, setValidationMessage] = useState("");
  const theme = useTheme();
  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
    setOpen1(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleGenerate = async () => {
    setLoader(true);
    try {
      await advanceSubtopicData(item.Topic, false, parseInt(count), index);
      setLoader(false);
    } catch (error) {
      console.error("Error occurred:", error);
      setLoader(false);
    }
  };

  const handleReGenerate = async () => {
    setIsLoading(true);
    try {
      await advanceSubtopicData(item.Topic, false, parseInt(count), index);
      setIsLoading(false);
    } catch (error) {
      console.error("Error occurred:", error);
      setIsLoading(false);
    }
  };

  const handleCountChange = event => {
    const { value } = event.target;
    if (!isNaN(value) && parseInt(value) > 0) {
      setCount(value);
      setDisabled(false);
      setValidationMessage("");
    } else {
      setCount("");
      setDisabled(true);
      setValidationMessage("Please enter a positive non-zero value.");
    }
  };

  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided, snapshot) => (
        <ListItem {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
          <Box className="TopicsWrapper">
            <Typography component="h4">{item.Topic}</Typography>
            <Typography component="p">
              {expandedIndex === index || item.Content.length <= 60 ? (
                item.Content
              ) : (
                <>
                  {item.Content.substring(0, 200)}
                  <Typography component="span" className="ReadMoreLess" onClick={() => handleReadMore(index)}>
                    ...Read More
                  </Typography>
                </>
              )}
              {expandedIndex === index && (
                <Typography component="span" className="ReadMoreLess" onClick={handleReadLess}>
                  Read Less
                </Typography>
              )}
            </Typography>
            <Box className="TopIconBarWrapper">
              <Box className="UpDownIcon">
                <DragHandleIcon titleAccess="Click To Drag" />
              </Box>
              <Box className="MinusIcon">
                <MoreVertIcon onClick={handleMenu} titleAccess="More Option" />
              </Box>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                sx={{
                  "& .MuiPopover-paper": {
                    overflow: "visible",
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 7,
                      width: 10,
                      height: 10,
                      bgcolor: theme.palette.background.default,
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                      borderTop: `1px solid ${theme.palette.divider}`,
                      borderLeft: `1px solid ${theme.palette.divider}`,
                    },
                    "& ul": {
                      p: "0",
                      borderRadius: "6px",
                      overflow: "hidden",
                      "& .menuitem": {
                        backgroundColor: theme.palette.background.default,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        p: "12px 18px",
                        "& > span.MuiTouchRipple-root": {
                          display: "none",
                        },
                        "& .DeleteIconWrapper": {
                          flex: "1",
                          textAlign: "end",
                          "& button": {
                            width: "100%",
                            "& svg": {
                              fontSize: "20px",
                              marginRight: "3px",
                            },
                          },
                        },
                        "& .GenerateCountWrapper": {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "15px",
                          "& button": {
                            minHeight: "36px",
                            minWidth: "auto",
                            "& .LoadingAnimated": {
                              animation: "RotateAnimated 1s linear infinite",
                              "@keyframes RotateAnimated": {
                                "0%": { transform: "rotate(0deg)" },
                                "100%": { transform: "rotate(360deg)" },
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem className="menuitem" title="Delete This List">
                  <Box className="DeleteIconWrapper">
                    <Button onClick={() => handleDelete(item)} title="Delete This List">
                      <DeleteIcon /> Delete
                    </Button>
                  </Box>
                </MenuItem>
                <MenuItem className="menuitem" title="Content Re-Generate">
                  <Box>
                    <Box className="GenerateCountWrapper">
                      <TextField
                        id="outlined-basic"
                        label="Regenerate"
                        variant="outlined"
                        type="number"
                        value={count}
                        onChange={e => handleCountChange(e)}
                        size="small"
                        style={{ width: "100%", maxWidth: "200px" }}
                      />
                      <Button onClick={handleGenerate} disabled={disabled}>
                        {loader ? <RefreshIcon className="LoadingAnimated" /> : <RefreshIcon />}
                      </Button>
                    </Box>
                    {validationMessage && <div style={{ color: "red" }}>{validationMessage}</div>}
                  </Box>
                </MenuItem>
              </Menu>
            </Box>
            <Box className="BottomIconBarWrapper" title="Re-fresh">
              <Button onClick={handleReGenerate}>{isLoading ? <RefreshIcon className="LoadingAnimated" /> : <RefreshIcon />}</Button>
            </Box>
          </Box>
        </ListItem>
      )}
    </Draggable>
  );
}
